/** A beat every minute; the server counts at most one in each. */
const BEAT_MS = 60_000;
/** Time played counts while the page is in sight and was touched this recently. */
const IDLE_MS = 3 * 60_000;

/**
 * Time played, for the campaign's stats page: a beat a minute to the server while the campaign is open, the
 * page is in sight and someone used it in the last few minutes. Returns the function that stops it.
 */
export const startPlayBeat = (campaignId: string): (() => void) => {
  let lastInput = Date.now();
  const touched = (): void => {
    lastInput = Date.now();
  };
  const events = ['pointerdown', 'keydown', 'wheel', 'touchstart'] as const;
  for (const e of events) window.addEventListener(e, touched, { passive: true, capture: true });
  const timer = window.setInterval(() => {
    if (document.visibilityState !== 'visible' || Date.now() - lastInput > IDLE_MS) return;
    void fetch(`/api/campaigns/${campaignId}/beat`, { method: 'POST', credentials: 'same-origin', keepalive: true }).catch(() => undefined);
  }, BEAT_MS);
  return () => {
    window.clearInterval(timer);
    for (const e of events) window.removeEventListener(e, touched, { capture: true });
  };
};
